/**
 * NOTE: This file is part of the legacy Notes feature.
 * User-facing text has been renamed to "Documentation" for clarity.
 * For the new Notes feature, check the Hub implementation.
 */

import { Note } from "@/lib/api/notes.ts";
import { NoteRenderer } from "@/components/conversation-details/notes/note-renderer";
import { useAuth } from "../../auth/auth-context";

interface NotesListProps {
  notes: Note[];
  menteeId: string;
  mentorId: string;
  adminMode?: boolean;
  pinnedNotes?: boolean;
}

export function NotesList({
  notes,
  pinnedNotes,
  adminMode,
  menteeId,
  mentorId,
}: NotesListProps) {
  const { user } = useAuth();
  return (
    <>
      {notes.map((note) => {
        const isNoteReadOnly =
          note.createdBy?.id !== user?.id ||
          note?.metadata?.type === "escalation";

        return (
          <NoteRenderer
            key={note.id}
            note={note}
            pinnedNotes={pinnedNotes}
            readonlyMode={isNoteReadOnly}
            adminMode={adminMode}
            menteeId={menteeId}
            mentorId={mentorId}
          />
        );
      })}
    </>
  );
}
